import * as actionTypes from "./actionTypes";
import router from "next/router";
import endpoints from "../../utility/endpoints";
import * as Msal from "msal";

export const sessionTimeOutCheck = (payload) => {
  return (dispatch) => {
    dispatch(sessionTimeOutChecking(payload));
    if (payload == false) {
      router.push("/login");
    }
  };
};
export const sessionTimeOutChecking = (data) => {
  return {
    type: actionTypes.sessionTimeOut,
    payload: data,
  };
};

const gettingAccessToken = () => {
  return {
    type: actionTypes.getAccessToken,
  };
};

const gettingAccessTokenSuccess = (data) => {
  return {
    type: actionTypes.getAccessTokenSuccess,
    payload: data,
  };
};

const gettingAccessTokenFailed = () => {
  return {
    type: actionTypes.getAccessTokenFailed,
  };
};

export function getAccessToken() {
  //console.log("getting access token again 1, Session");
  try {
    //console.log("getting access token again, Session");
    const msalConfig = {
      auth: {
        clientId: `${endpoints.clientId}`,
        authority: `${endpoints.authority}`,
        redirectUri: endpoints.redirectUriLogin,
      },
    };
    const msalInstance = new Msal.UserAgentApplication(msalConfig);
    var loginRequest = {
      scopes: ["offline_access"], // optional Array<string>
    };
    msalInstance.acquireTokenSilent(loginRequest).then((response) => {
      //console.log("got access token again, Session", response);
      let auth = JSON.parse(localStorage.getItem("auth"));
      auth.data.accessToken = response.accessToken;
      auth.data.expiresOn = response.expiresOn;
      localStorage.setItem("auth", JSON.stringify(auth));
      return true
    }).catch((error)=>{
      console.log(error, "Session in");
      return false;  
    })

    return true;
  } catch (error) {
    console.log(error, "Session");
    return false;
  }
}

export function checkExpiry(auth) {
  return async (dispatch, getState, api) => {
    {/*console.log(
      new Date(auth.expiresOn),
      "first",
      new Date(auth.expiresOn).getMinutes(), "middle",
      new Date(auth.expiresOn),
      "second",
      new Date(),
      "third",
      new Date(auth.expiresOn) > new Date(),
      "Checking date difference , Session"
    );*/}
    let myDate = new Date(auth.expiresOn)
   //console.log(myDate, "number1")
    let minutes = myDate.getMinutes()
    //console.log(minutes, "number2")
    if (minutes <10) {
     myDate.setMinutes(60-(10-minutes))
     myDate.setHours(myDate.getHours()-1)
    }
    else {
      myDate.setMinutes(minutes-10)
    }
    //console.log(myDate, "number3")
    
  
    if (myDate > new Date()) {
      return true;
    } else {
      //console.log("fetching new token , Session");
      let newTokenStatus = await getAccessToken();
      if (newTokenStatus) {
        return true;
      } else {
        return false;
      }
    }
  };
}
